// Lightweight helpers around Google Analytics gtag.js (loaded in index.html).
// All calls are no-ops if gtag isn't yet on the window (e.g. blocked, offline).

function safeGtag(...args) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    try {
      window.gtag(...args);
    } catch (_) {}
  }
}

/** Track an arbitrary custom event with optional params. */
export function track(eventName, params = {}) {
  safeGtag("event", eventName, params);
}

/** Track a page view manually (useful for SPA route changes). */
export function trackPageView(path) {
  safeGtag("event", "page_view", { page_path: path });
}

/** Identify the logged-in user (sets user_id in GA4). */
export function setUserId(userId) {
  if (!userId) return;
  safeGtag("set", { user_id: userId });
}

// Named events used across the app (single source of truth)
export const EVENTS = {
  SIMULATE_LINK_DROP: "simulate_link_drop",
  SIMULATE_SOC_ATTACK: "simulate_soc_attack",
  EXPORT_REPORT: "export_report",
  LEAD_FORM_SUBMIT: "lead_form_submit",
  LEAD_CAPTURE_SUCCESS: "lead_capture_success",
  COCKPIT_LOGIN: "cockpit_access_log",
};
